import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xlcp8va0u: FaireProductEntity = {
  token: "p_3xlcp8va0u",
  type: "product",
  name: "Spearmint & Eucalyptus Bath Bomb",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/83cc8359b5e16cd893160587ea742eab3310e6db6d79d7fec4bb87e809d23655.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/db7643280c8feb1e430a75b1601d63aba9550ed3c1d5d4991f4da2701e699c48.jpeg",
    "https://cdn.faire.com/fastly/e50136ebbefa777a4c493ea0653e64b218c0366d20eb20d3c1c4abc7f010162a.jpeg",
    "https://cdn.faire.com/fastly/dcf302fdb2b15da520ac5bbc22d5378bc7638b7cf2de07e592b58491200cc19f.jpeg",
    "https://cdn.faire.com/fastly/71ffaacf998e9e77ec25a8628f2e62d872422d447f9a0ba5ba2125c187ccea0a.jpeg",
  ],
  priceDollars: 4,
  description:
    "Rejuvenate the senses with two of nature’s best aromas, brisk spearmint and cooling eucalyptus. This clean, cool scent is made with an essential oil and fragrance oil blend. Spearmint & Eucalyptus is perfect for an invigorating start to your day or pick-me-up or as a way to relax and unwind in the evening. This bath bomb is color free with spearmint leaves.  This scent is loved by both men and women; great for winter!\n \nTop: Spearmint, Eucalyptus, Wild Mint\nBase: Mint, Orange, Peppermint\n\nHandmade in historic Charleston, SC, with baking soda, citric acid, epsom salts, olive, and soybean oil, each Old Whaling Co. 8oz bath bomb will leave your skin feeling moisturized and lightly scented. Our handcrafted bath bomb's soothing fizz and sea-inspired fragrance are perfect for a relaxing soak, rejuvenating the senses and cleansing the skin. At 2.75” round.\n\nOur bath bombs come boxed, and are wrapped in cellophane bags inside the box.\n\nOur bath bombs always make for great gifts!",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:21.681Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
